import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import EventForm from './EventForm';
import * as actions from './redux/actions';
import { drapcodeIcon } from '../../common/custom/icon-library';
import DocsLink from '../../common/custom/DocsLink';
import ParentDocCard from '../common/ParentDocCard';

export class CreateEvent extends Component {
  static propTypes = {
    events: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { actions, match } = this.props;
    const { projectId, version } = match.params;
    actions.loadPagesInEvent({ projectId, version });
    actions.loadDefaultPage({ projectId, version });
    actions.loadCollectionsInEvent({ projectId, version });
    actions.loadSnippetsInEvent({ projectId, version });
  }

  render() {
    const { actions, events, match, history } = this.props;
    const { projectId, version } = match.params;
    const { saveNewEventPending } = events;
    const showLoader = saveNewEventPending !== undefined && saveNewEventPending;
    return (
      <div className="events-create-event">
        <div className="main">
          <div className="section">
            <div className="container">
              <div className="row mx-auto">
                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                  <div className="card">
                    <div
                      className="card-header card-header-icon"
                      data-background-color="drapcode-dark-blue"
                    >
                      <i className={`wb ${drapcodeIcon('events')}`}></i>
                    </div>
                    <div className="card-content">
                      <EventForm
                        actions={actions}
                        projectId={projectId}
                        showLoader={showLoader}
                        event={{}}
                        history={history}
                        showLoaderForDeleteEvent={false}
                        isUpdateForm={false}
                        version={version}
                      />
                    </div>
                  </div>
                </div>
                <ParentDocCard>
                  <h5>
                    <b>About Events </b>
                  </h5>
                  <p>
                    Allows you to create multiple automated workflows for varied purposes such as to
                    save, update and delete collection data, add & remove data from a collection,
                    show/close modal, notifications, page reload, page refresh, show/hide components
                    etc. You can create events to add dependent dropdown and send dynamic emails.
                  </p>
                  <DocsLink link="https://academy.drapcode.com/docs/app-event/event-introduction" />
                  <br />
                </ParentDocCard>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    events: state.events,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateEvent);
